import { useSnapshot } from "valtio";
import { clientDashboardEvents, TreeNode } from "../clientDashboardEvents";
import { findCampaign, startsInFuture } from "../campaignDates";

/**
 * Shown in place of the charts when the one campaign in scope has not started (MPN-1964 AC3).
 *
 * A campaign that has not run has no conversions, and a row of zeroes beside a conversion
 * line flat on the axis reads as a campaign performing badly rather than one that has not
 * begun. That is the complaint this ticket opens with.
 *
 * The dates are deliberately not repeated here. The card directly above already carries the
 * flight, and this said "This campaign starts Jun 3" in October for a campaign scheduled in
 * June that nobody ever published — Upcoming means "has not run", not "starts later".
 */
export default function UpcomingCampaignNotice() {
    const snap = useSnapshot(clientDashboardEvents);
    const campaign = findCampaign(snap.filterTree as TreeNode[], snap.launch);
    if (!campaign || campaign.status !== "UPCOMING") return null;

    return (
        <div className="dash-notice">
            <div className="dash-notice__title">No performance to show yet</div>
            <div className="dash-notice__body">
                {startsInFuture(campaign)
                    ? "This campaign has not started. Results appear here once it begins."
                    : "This campaign has not started serving. Results appear here once it does."}
            </div>
        </div>
    );
}
